import { Model as i } from "../../../../../model.js";
class t extends i {
  constructor(s) {
    super(), this.id = s.id, this.icon = s.icon, this.label = s.label, this.description = s.description, this.options = s.options, this.type = s.type, this.status = s.status, this.required = s.required, this.services = s.services;
  }
}
export {
  t as ShopSessionCheckoutFieldModel
};
//# sourceMappingURL=checkoutField.model.js.map
